var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3945_4514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.6875H3.0625V14H1.75C0.784766 14 0 13.2152 0 12.25V1.75C0 0.784766 0.784766 0 1.75 0H6.27539C6.74023 0 7.18594 0.183203 7.51406 0.511328L9.98867 2.98594C10.3168 3.31406 10.5 3.75977 10.5 4.22461V8.3125H9.1875V4.375H7C6.51602 4.375 6.125 3.98398 6.125 3.5V1.3125H1.75C1.50937 1.3125 1.3125 1.50937 1.3125 1.75V12.25C1.3125 12.4906 1.50937 12.6875 1.75 12.6875ZM4.8125 9.625H5.6875C6.53242 9.625 7.21875 10.3113 7.21875 11.1562C7.21875 12.0012 6.53242 12.6875 5.6875 12.6875H5.25V13.5625C5.25 13.8031 5.05312 14 4.8125 14C4.57188 14 4.375 13.8031 4.375 13.5625V10.0625C4.375 9.82187 4.57188 9.625 4.8125 9.625ZM5.6875 11.8125C6.05117 11.8125 6.34375 11.5199 6.34375 11.1562C6.34375 10.7926 6.05117 10.5 5.6875 10.5H5.25V11.8125H5.6875ZM8.3125 9.625H9.1875C9.91211 9.625 10.5 10.2129 10.5 10.9375V12.6875C10.5 13.4121 9.91211 14 9.1875 14H8.3125C8.07187 14 7.875 13.8031 7.875 13.5625V10.0625C7.875 9.82187 8.07187 9.625 8.3125 9.625ZM9.1875 13.125C9.42813 13.125 9.625 12.9281 9.625 12.6875V10.9375C9.625 10.6969 9.42813 10.5 9.1875 10.5H8.75V13.125H9.1875ZM11.375 10.0625C11.375 9.82187 11.5719 9.625 11.8125 9.625H13.125C13.3656 9.625 13.5625 9.82187 13.5625 10.0625C13.5625 10.3031 13.3656 10.5 13.125 10.5H12.25V11.375H13.125C13.3656 11.375 13.5625 11.5719 13.5625 11.8125C13.5625 12.0531 13.3656 12.25 13.125 12.25H12.25V13.5625C12.25 13.8031 12.0531 14 11.8125 14C11.5719 14 11.375 13.8031 11.375 13.5625V11.8125V10.0625Z",
    fill: "url(#paint0_linear_3945_4514)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3945_4514",
    x1: 13.5625,
    y1: 7,
    x2: -2.65842e-7,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37384B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3945_4514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocPdf);
export default __webpack_public_path__ + "static/media/doc-pdf.6251e3c4156e1c2cbed05b6cd6b1e4ad.svg";
export { ForwardRef as ReactComponent };